(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('ResultatTechnicienController', ResultatTechnicienController);

    ResultatTechnicienController.$inject = ['$state', 'ParseLinks', 'AlertService', 'pagingParams', '$filter', 'paginationConstants', 'ResultatTechnicien', 'Technicien', 'DateUtils', 'ChargeTechnicien', 'Config'];

    function ResultatTechnicienController($state, ParseLinks, AlertService, pagingParams, $filter, paginationConstants, ResultatTechnicien, Technicien, DateUtils, ChargeTechnicien, Config) {
        var vm = this;

        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;

        vm.filterTechnicien = pagingParams.technicien;
        vm.filterType = pagingParams.type;
        vm.filterDateTo = new Date(pagingParams.dateTo);
        vm.filterDateFrom = new Date(pagingParams.dateFrom);

        vm.getTotal = getTotal;
        vm.getCATotal = getCATotal;
        vm.getChargeTotal = getChargeTotal;
        vm.search = search;
        vm.addChargePreviousMonth = addChargePreviousMonth;
        vm.transition = transition;
        vm.reportChargeBtnDisable = false;

        DateUtils.loadCutoffDay().then(function () {
            if (!pagingParams.dateFrom && !pagingParams.dateTo) {
                getAllDates();
            }
            loadAll();
            loadTechniciens();
            getLastMonthChargeReportDate();
        });

        function loadAll() {
            vm.filterType = vm.filterType === "" ? null : vm.filterType;
            // Format local (pas toISOString/UTC) : un Date à minuit local serait
            // converti a la veille en UTC+2 et la plage chevaucherait 2 periodes de paie.
            ResultatTechnicien.query({
                dateFrom: $filter('date')(vm.filterDateFrom, 'yyyy-MM-dd'),
                dateTo: $filter('date')(vm.filterDateTo, 'yyyy-MM-dd'),
                technicien: vm.filterTechnicien,
                type: vm.filterType,
                civilMonth: true
            },onSuccess, onError);
        }

        function addChargePreviousMonth() {
            ChargeTechnicien.addChargePreviousMonth({}, function onSuccess(data, headers) {
                getLastMonthChargeReportDate();
                loadAll();
                AlertService.success("Charges ajoutées avec succès");
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function getLastMonthChargeReportDate() {
            Config.getByName({name: 'date_dernier_mois_creation_charge'}, function onSuccess(data, headers) {
                var dateString = data.value;
                var parts = dateString.split("-");
                var date = new Date(parts[0], parts[1] - 1, parts[2]);
                vm.lastMonthChargeReportDate = date;
                adaptReportChargeBtn();
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function loadTechniciens(){
            Technicien.technicienEnabledHistory ({ }, function onSuccess(data, headers) {
                vm.techniciens = data;
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function onSuccess(data, headers) {
            vm.resultatTechniciens = data;
        }
        function onError(error) {
            AlertService.error(error.data.message);
        }

        function getTotal(){
            var total=0;
            if(vm.resultatTechniciens){
                vm.resultatTechniciens.forEach(function(resultat) {
                    if(resultat.price){
                        total+=resultat.price;
                    }
                });
            }
            return numberWithSpace(total.toFixed(2));
        }

        function adaptReportChargeBtn() {
            var now = new Date();
            var firstDayOfPeriod = DateUtils.getFirstDayOfPayrollPeriod(now);
            var lastDayOfPeriod = DateUtils.getLastDayOfPayrollPeriod(now);
            lastDayOfPeriod.setHours(23,59,59,999);

            if (firstDayOfPeriod <= vm.lastMonthChargeReportDate && vm.lastMonthChargeReportDate <= lastDayOfPeriod) {
                vm.reportChargeBtnDisable = true;
            } else {
                vm.reportChargeBtnDisable = false;
            }
        }

        function getCATotal(){
            var ca=0;
            if(vm.resultatTechniciens){
                vm.resultatTechniciens.forEach(function(resultat) {
                    if(resultat.price && resultat.price > 0){
                        ca+=resultat.price;
                    }
                });
            }
            return numberWithSpace(ca.toFixed(2));
        }

        function getChargeTotal(){
            var charge=0;
            if(vm.resultatTechniciens){
                vm.resultatTechniciens.forEach(function(resultat) {
                    if(resultat.price && resultat.price < 0){
                        charge+=resultat.price;
                    }
                });
            }
            return numberWithSpace(charge.toFixed(2));
        }

        function numberWithSpace(x) {
            if(x){
                var parts = x.toString().split(".");
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                return parts.join(".");
            }else{
                return null;
            }
        }

        function getAllDates() {
            var now = new Date();
            vm.filterDateFrom = DateUtils.getFirstDayOfPayrollPeriod(now);
            vm.filterDateTo = DateUtils.getLastDayOfPayrollPeriod(now);
        }

        vm.previousMonth=function(){
            var next = new Date(vm.filterDateFrom.getFullYear(), vm.filterDateFrom.getMonth() + 1, 1);
            vm.filterDateFrom = DateUtils.getFirstDayOfPayrollPeriod(next);
            vm.filterDateTo = DateUtils.getLastDayOfPayrollPeriod(next);
            vm.filterDateFrom = $filter('date')(vm.filterDateFrom,'yyyy-MM-dd');
            vm.filterDateTo = $filter('date')(vm.filterDateTo,'yyyy-MM-dd');
            transition();
        }

        vm.nextMonth=function(){
            var next = new Date(vm.filterDateFrom.getFullYear(), vm.filterDateFrom.getMonth() + 1, 1);
            vm.filterDateFrom = DateUtils.getFirstDayOfPayrollPeriod(next);
            vm.filterDateTo = DateUtils.getLastDayOfPayrollPeriod(next);
            vm.filterDateFrom = $filter('date')(vm.filterDateFrom,'yyyy-MM-dd');
            vm.filterDateTo = $filter('date')(vm.filterDateTo,'yyyy-MM-dd');
            transition();
        }

        vm.previousDay=function (){
            var date = new Date(vm.filterDateFrom);
            date.setDate(date.getDate() - 1);
            var tmpDateTo = new Date(vm.filterDateTo);
            tmpDateTo.setDate(tmpDateTo.getDate() - 1);
            vm.filterDateFrom = $filter('date')(date,'yyyy-MM-dd');
            vm.filterDateTo = $filter('date')(tmpDateTo,'yyyy-MM-dd');
            transition();
        }

        vm.nextDay=function (){
            var date = new Date(vm.filterDateFrom);
            date.setDate(date.getDate() + 1);
            var tmpDate = new Date(vm.filterDateTo);
            tmpDate.setDate(tmpDate.getDate() + 1);
            vm.filterDateFrom = $filter('date')(date,'yyyy-MM-dd');
            vm.filterDateTo = $filter('date')(tmpDate,'yyyy-MM-dd');
            transition();
        }

        function search(){
            transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                dateFrom: vm.filterDateFrom,
                dateTo: vm.filterDateTo,
                technicien: vm.filterTechnicien,
                type: vm.filterType,
            });
        }

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
